import { sampleQueryKeys } from '@/config/queryKeys';
import { getSelectedOrg } from '@/helpers';
import { agGridDatasourceQueryKey } from '@/lib/createAgGridDatasource';
import type { SampleWithNamesPublic } from '@/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/samples/$sampleId')({
  beforeLoad: ({ context, location }) => {
    const selectedOrganization = getSelectedOrg();

    if (context.authentication.status === 'UNAUTHENTICATED') {
      throw redirect({ to: '/login' });
    }

    if (!selectedOrganization) {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('unauthorized_referrer', location.pathname);
      }
      throw redirect({ to: '/unauthorized' });
    }
  },
  loader: ({ context: { queryClient }, params: { sampleId } }) => {
    const orgId = getSelectedOrg()?.id;
    if (!orgId) return;

    const detailKey = sampleQueryKeys.detail(orgId, sampleId);
    if (queryClient.getQueryData(detailKey)) return;

    // The real GET /orgs/{orgId}/samples/{sampleId} endpoint is not yet available.
    // Seed the detail cache entry by scanning the AG Grid list cache (populated
    // when the user navigates from the samples list page).
    const agGridPrefix = agGridDatasourceQueryKey(sampleQueryKeys.endpoints.listSearch(orgId));
    const cachedPages = queryClient.getQueriesData<{ total: number; records: SampleWithNamesPublic[] }>({
      queryKey: agGridPrefix,
    });

    for (const [, page] of cachedPages) {
      const match = page?.records?.find(s => s.id === sampleId);
      if (match) {
        queryClient.setQueryData(detailKey, match);
        return;
      }
    }
  },
});
